import HomePage from './pages/HomePage';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  )
}

export default App;
